import './App.css';
import GithubSearch from "./components/GithubSearch";

function App() {
  return (
    <div className="bg-green-50 font-Poppins">
      <GithubSearch />
    </div>
  );
}

export default App;
